import { Resource } from './resource';
import gql from 'graphql-tag';

export class TagResource extends Resource {
  public static async list() {
    return await this.query(
      {
        query: gql`
          query {
            tags {
              id
              name
            }
          }
        `
      },
      'tags'
    );
  }
}
